import {Component, OnInit, Optional} from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {AbstractComponent} from "@components";
import {FormControl, FormGroup} from "@angular/forms";
import {
  alphabetical,
  max_length_45,
  required,
} from "@utility";

@Component({
  selector: 'app-my-tracey-create-list',
  templateUrl: './my-tracey-create-list.component.html',
  styleUrl: './my-tracey-create-list.component.scss',
  standalone: false
})
export class MyTraceyCreateListComponent extends AbstractComponent implements OnInit {

  inputForm: FormGroup<{
    listName: FormControl<string | null>;
    description: FormControl<string | null>;
  }> = new FormGroup({
    listName: new FormControl('', [
      required,
      alphabetical,
      max_length_45
    ]),
    description: new FormControl('', [
      alphabetical,
      max_length_45
    ])
  });

  constructor(@Optional() public activeModal: NgbActiveModal) {
    super();
  }

  ngOnInit(): void {
  }

  onClose() {
    this.activeModal.close();
  }

}
